import { AxiosRequestConfig } from 'axios';
import qs from 'query-string';

import { httpApiClient } from 'configs/http-client';
import { MetaPayload } from 'interfaces';
import { GetLeadsPayload } from 'interfaces/leads.interfaces';

export class LeadsApis {
  constructor(private url: string) {}

  getLeads({ page, per_page = 10, sort, order, query, filter }: MetaPayload, config?: AxiosRequestConfig) {
    return httpApiClient.get<GetLeadsPayload>(
      `${this.url}?${qs.stringify({ page, per_page, sort, order, q: query })}${filter ? `&${filter}` : ''}`,
      config,
    );
  }
}

export const leadsApi = new LeadsApis('/admin/leads');
